export const NEXT_PUBLIC_API_BASE_URL =
  process.env.NEXT_PUBLIC_API_BASE_URL ?? "";

export const NEXT_PUBLIC_SOCKET_IO_URL =
  process.env.NEXT_PUBLIC_SOCKET_IO_URL ?? "";

export const NEXT_PUBLIC_CLOUDFRONT_URL =
  process.env.NEXT_PUBLIC_CLOUDFRONT_URL ?? "";

export const NEXT_PUBLIC_ENV_NAME = process.env.NEXT_PUBLIC_ENV_NAME ?? "";

export const NEXT_PUBLIC_KLIPY_API_KEY =
  process.env.NEXT_PUBLIC_KLIPY_API_KEY ?? "";

export const NEXT_PUBLIC_MIXPANEL_TOKEN =
  process.env.NEXT_PUBLIC_MIXPANEL_TOKEN ?? "";

export const NEXT_PUBLIC_LAUNCHDARKLY_SDK_CLIENT_SIDE_ID =
  process.env.NEXT_PUBLIC_LAUNCHDARKLY_SDK_CLIENT_SIDE_ID ?? "";

export const NEXT_PUBLIC_SENTRY_DSN = process.env.NEXT_PUBLIC_SENTRY_DSN ?? "";

export const NEXT_PUBLIC_VIRTUOSO_LICENSE_KEY =
  process.env.NEXT_PUBLIC_VIRTUOSO_LICENSE_KEY ?? "";

export const NEXT_PUBLIC_IFRAME_RESIZER_LICENSE_KEY =
  process.env.NEXT_PUBLIC_IFRAME_RESIZER_LICENSE_KEY ?? "";

export const NEXT_PUBLIC_PARALLEL_MULTIPART_UPLOADS = parseInt(
  process.env.NEXT_PUBLIC_PARALLEL_MULTIPART_UPLOADS ?? "5",
  10,
);
